import layout from '@/views/layout/layout.vue'
const chartList = r => require.ensure([], () => r(require('@/views/marketing/chart/list.vue')), 'group-marketing-chart')

const marketingChart = [
  {
    path: '/marketing/chart',
    name: 'marketing-chart',
    component: layout,
    redirect: '/marketing/chart/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: chartList,
        name: 'marketing-chart-list',
        meta: {
          displayName: '营销报表管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default marketingChart



// WEBPACK FOOTER //
// ./src/router/marketing/Chart.js